import Routes from './routes';
import Header from './components/Header';

function App() {
  return (
    <div>
    <Routes/>
    </div>
  );
}

export default App;
